import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '@/lib/auth';

export default function GoogleAuthButton() {
  const { googleLogin } = useAuth();

  const handleSuccess = async (credentialResponse) => {
    try {
      await googleLogin(credentialResponse.credential);
      window.location.href = '/app/bookings';
    } catch (err) {
      console.error(err);
      alert('Google login failed');
    }
  };

  return (
    <div className="w-full flex justify-center">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => alert('Google Login Failed')}
        theme="filled_black"
        shape="pill"
        size="large"
        text="continue_with"
      />
    </div>
  );
}